import React from 'react';
import css from './PurchaseProtectionPage.module.css';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { LayoutSingleColumn, Page } from '../../components';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';


const PurchaseProtectionPageComponent = props => {
  const { scrollingDisabled, intl, history } = props;

  return (
    <Page title={'Purchase Protection'} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.wrapper}>
          <p className={css.title}>
            The Comp Closet Purchase Protection
          </p>

          <p className={css.info}>
            You are protected whenever you make any purchase on The Comp Closet. We are able to provide a full refund if your item never ships or does not match the listing description*. Otherwise, all sales are final. The system we have in place to protect you is called The Comp Closet Purchase Protection. By purchasing on The Comp Closet, you accept the following terms.
          </p>

          <p className={css.subTitle}>
            How it Works
          </p>

          <p className={css.info}>
            We have you covered with peace of mind shopping! While most sales are seamless and are completed within just a few days, we are able to hold your payment for you after your purchase and give you plenty of time to request a refund or return if needed. However, it's only fair to pay sellers as quickly as possible, so Purchase Protection will automatically end earlier when:
          </p>

          <ul>
            <li className={css.info}>
              • Your order has been marked as “Delivered”. You will still have 24 hours after delivery to inspect your purchase and make sure it meets the description in the listing.
            </li>
            <li className={css.info}>
              • It has been a reasonable period of time since the purchase was made and we haven't heard from you.
            </li>
            <li className={css.info}>
              • You confirm that you received your item or leave positive feedback for the seller.
            </li>
          </ul>

          <p className={css.info}>
            Please note: Once the Purchase Protection period ends you will not be able to request a refund or return.
          </p>

          <p className={css.subTitle}>
            What is covered when your item is different from the listing description
          </p>
          <p className={css.info}>
            If any of the following pertain to your order - we recommend opening a dispute immediately:
          </p>

          <ul>
            <li className={css.info}>
              • Incorrect or missing item/s
            </li>
            <li className={css.info}>
              • Undisclosed damage E.g. There's a stain or rip that wasn't mentioned
            </li>
            • Item not as described E.g. The item is a different size than what it was listed at
            <li className={css.info}>
              • If a return is authorised, you must submit a tracking number for the return within 5 days of approval to be eligible for a refund. Please note that The Comp Closet will not reimburse return postage.
            </li>
          </ul>

          <p className={css.info}>
            Please note: you must open any disputes within The Comp Closet Purchase Protection period.
          </p>

          <p className={css.info}>
            Disclaimer: The Comp Closet is a marketplace for secondhand items, and while it is fair and reasonable to expect that your item is consistent with the listing description - it is also important to thoroughly read the listing description and ask any questions if you have any. In the interest of fairness to both Buyers and Sellers - it is at The Comp Closet’s sole discretion to issue a full or partial refund for any dispute pertaining to consistency with the listing description.
          </p>

          <p className={css.subTitle}>
            What is not covered
          </p>

          <p className={css.info}>
            It's important to note that The Comp Closet Purchase Protection does not cover issues with fit or style, or change of mind. However, you can always re-list the item on The Comp Closet, or get the item altered!
          </p>
          <p className={css.info}>
            If a refund is processed, please note that all refunds are processed in the original currency of purchase. Any discrepancies in refund amounts due to exchange rates or processing fees are dictated by your bank or card issuer's international transaction policies, which are beyond our control.
          </p>

          <p className={css.subTitle}>
            Trading off the platform
          </p>

          <p className={css.info}>
            The Comp Closet does not cover trades or transactions not completed on The Comp Closet. When payment for the full value of items is not made via The Comp Closet platform, we are unable to guarantee that both parties will ship and transact as promised. You accept all risks associated with any such transactions. We made The Comp Closet to be as safe as possible - that is why trading off the site is against our Terms of Use and may result in your membership being restricted or cancelled.
          </p>
        </div>
      </LayoutSingleColumn>
    </Page >
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const PurchaseProtectionPage = compose(
  withRouter,
  connect(mapStateToProps),
  injectIntl
)(PurchaseProtectionPageComponent);

export default PurchaseProtectionPage;
